/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleVersionApprovalType } from './moduleVersionApprovalType';

export type ApprovalRequestApprovalType = ModuleVersionApprovalType | null;
